import { createStyles, withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

export const Date = withStyles(() =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  })
)(FsBodySmall);

export const Time = withStyles(({ spacing, palette }) =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
      paddingLeft: spacing(1.5),
      position: 'relative',
      marginLeft: spacing(1.5),
      '&:after': {
        position: 'absolute',
        content: '""',
        width: spacing(1),
        height: spacing(1),
        borderRadius: spacing(0.5),
        background: palette.grey[200],
        top: '50%',
        left: 0,
        transform: 'translate(-50%, -50%)',
      },
    },
  })
)(FsBodySmall);

export const Weekday = withStyles(() =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  })
)(FsBodySmall);
